import React from "react";
import { Descriptions } from "antd";
import { observer } from "mobx-react";

export const ArticleInfo = observer(({ article }) => {
  return (
    <Descriptions>
      <Descriptions.Item label="Title">{article.title}</Descriptions.Item>
      <Descriptions.Item label="Type">{article.type}</Descriptions.Item>
      <Descriptions.Item label="Retired">{article.retired ? "Yes" : "No"}</Descriptions.Item>
    </Descriptions>
  );
});
